import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useDeletePersonaMutation} from '../hooks/usePersonasQuery';
import {usePersonasSelection} from '../hooks/usePersonasSelection.ts';

export const DeleteRecordButton = () => {

    const deleteMutation = useDeletePersonaMutation();

    const {
        selection,
        handleClearSelection,
    } = usePersonasSelection();

    const recordIds = Object.keys(selection)
                            .filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);
};
